module.exports = __webpack_public_path__ + "img/MH_DEVPROD_Transparent.f73e0012.png";